/**
 * @file Shared page-header component.
 *
 * Every admin page (and /me) renders the same shape at the top: a large
 * title, a muted subtitle/description. Centralising here so the markup
 * and spacing stays uniform — if a future redesign tweaks the heading
 * or adds a breadcrumb slot, it lands in one place rather than seven.
 *
 * Audit log deliberately keeps its own filter row immediately after the
 * header (different UX needs); this helper only renders the title +
 * subtitle block, not whatever comes below.
 *
 * @param {string} title       Page title, rendered as uppercase display font.
 * @param {string|Node} subtitle  Short muted line under the title. Strings
 *                                are wrapped in a <p>; a DOM node is used
 *                                as-is for rich content.
 */

import { el } from './utils.js';

export function renderPageHead(title, subtitle = null) {
  const children = [el('h1', { class: 'title' }, title)];
  if (subtitle != null) {
    const node = typeof subtitle === 'string'
      ? el('p', { class: 'muted' }, subtitle)
      : subtitle;
    children.push(node);
  }
  return el('section', { class: 'page-head' }, ...children);
}
